import { render, staticRenderFns } from "./CMSSemanticPage.vue?vue&type=template&id=baac5e20&lang=pug&"
import script from "./CMSSemanticPage.vue?vue&type=script&lang=ts&"
export * from "./CMSSemanticPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports